import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, normalizeStyle as _normalizeStyle, withCtx as _withCtx, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "result-image__content"
}
const _hoisted_2 = { class: "result-image__inner" }
const _hoisted_3 = {
  key: 0,
  class: "result-image__tabs"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "handle",
  slot: "handle"
}
const _hoisted_7 = { class: "d-flex align-center justify-center fill-height" }
const _hoisted_8 = { class: "d-flex align-center justify-center fill-height" }
const _hoisted_9 = {
  key: 0,
  class: "overlay-loading"
}
const _hoisted_10 = { class: "services__list" }
const _hoisted_11 = { class: "services__list__item__icon" }
const _hoisted_12 = { class: "services__list__item__title" }

import { storeToRefs } from 'pinia';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { ImgComparisonSlider } from '@img-comparison-slider/vue';

import { downloadImage } from '@/utils/downloadImage';

import { TService } from '@/types/TService';
import { TTabItem } from '@/types/TTabItem';
import { IMultiMenuItem } from '@/types/IMultiMenuItem';

import { useCommonStore } from '@/store/common';
import { useEditorStore } from '@/store/editor';
import { useServicesStore } from '@/store/services';

import AiBottomModal from '@/components/UI/AiBottomModal/AiBottomModal.vue';
import AiButton from '@/components/UI/AiButton/AiButton.vue';
import AiCircleLoader from '@/components/UI/AiCircleLoader/AiCircleLoader.vue';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
import AiTabs from '@/components/UI/AiTabs/AiTabs.vue';

import ImageFinetune from '@/components/common/ImageFinetune/ImageFinetune.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResultImage',
  setup(__props) {

const { t } = useI18n();

const { isMobile, currentService, servicesList } = storeToRefs(useCommonStore());
const { imageForActions, imagePrev, imageResult, loading } = storeToRefs(useServicesStore());
const { generateImageData } = storeToRefs(useEditorStore());

const imageTab = ref<string>('');
const mainImageRef = ref<any | null>(null);
const imageWidth = ref<number>(1);
const imageHeight = ref<number>(1);
const otherServiceModal = ref<boolean>(false);
const isEdit = ref<boolean>(false);
const imageTabs = ref<TTabItem[]>([
  {
    label: t('services.comparison'),
    value: 'comparison',
  },
  {
    label: t('services.before'),
    value: 'before',
  },
  {
    label: t('services.after'),
    value: 'after',
  },
]);

const localServicesList = ref<any>([
  {
    title: t('multi-menu.market-title'),
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/market.svg'),
    service: 'create_background_for_image',
  },
  {
    title: t('multi-menu.remove-background-title'),
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/remove-background.svg'),
    service: 'remove_background',
  },
  {
    title: t('multi-menu.infographics-title'),
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/infographics.svg'),
    service: 'infographics',
  },
  {
    title: t('multi-menu.upscale-title'),
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/upscale.svg'),
    service: 'upscale',
  },
  // {
  //   title: t('multi-menu.watermarks-title'),
  //   // eslint-disable-next-line global-require
  //   icon: require('@/assets/icons/multi-menu/watermarks.svg'),
  //   service: 'Watermarks',
  // },
  {
    title: t('multi-menu.outpaint-title'),
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/outpaint.svg'),
    service: 'outpaint',
  },
  {
    title: t('multi-menu.inpaint-title'),
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/inpaint.svg'),
    service: 'inpaint',
  },
  // {
  //   title: t('multi-menu.shadow-title'),
  //   // eslint-disable-next-line global-require
  //   icon: require('@/assets/icons/multi-menu/shadow.svg'),
  //   service: 'Shadow',
  // },
]);

// eslint-disable-next-line max-len
const computedMenuList = computed(() => localServicesList.value.filter((menuItem: IMultiMenuItem) => servicesList.value.find((serviceItem: TService) => menuItem.service === serviceItem)));

const downloadHandler = (): void => {
  const ext = imageResult.value.substring('data:image/'.length, imageResult.value.indexOf(';base64'));
  downloadImage({
    url: imageResult.value,
    name: `result.${ext}`,
  });
};

const goToServiceHandler = (name: TService): void => {
  imageForActions.value = imageResult.value;
  imageResult.value = '';
  currentService.value = name;
  if (name === 'create_background_for_image') {
    localStorage.setItem('step', '3');
  } else if (name === 'remove_background') {
    localStorage.setItem('to-remove-bg', 'true');
  }
};

const otherServiceModalCloseHandler = (): void => {
  otherServiceModal.value = false;
};

const imageSizeHandler = (): void => {
  if (imageForActions.value !== '') {
    const img = new Image();
    img.onload = () => {
      imageWidth.value = img.width;
      imageHeight.value = img.height;
    };
    img.src = imageForActions.value;
  }
};

const toEditHadler = ():void => {
  isEdit.value = true;
};

const resetHandler = (): void => {
  isEdit.value = false;
};

const editHandler = async (image: string): Promise<void> => {
  imageResult.value = image;
  isEdit.value = false;
};

onMounted(() => {
  imageSizeHandler();
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["result-image", { 'result-image--mobile': _unref(isMobile) }])
  }, [
    (!isEdit.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_unref(imageForActions) !== '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(AiTabs, {
                    modelValue: imageTab.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((imageTab).value = $event)),
                    items: imageTabs.value,
                    type: "square"
                  }, null, 8, ["modelValue", "items"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["result-image__box", { 'mt-8': _unref(imageForActions) === '' }])
            }, [
              _createElementVNode("div", {
                class: "result-image__box__img",
                style: _normalizeStyle({ 'aspect-ratio': imageWidth.value / imageHeight.value })
              }, [
                _withDirectives(_createVNode(_unref(ImgComparisonSlider), {
                  class: "result-image__box__slider",
                  style: _normalizeStyle({ 'aspect-ratio': imageWidth.value / imageHeight.value })
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      slot: "first",
                      class: "first",
                      style: {"width":"100%","box-sizing":"border-box"},
                      src: _unref(imageForActions),
                      alt: ""
                    }, null, 8, _hoisted_4),
                    _createElementVNode("img", {
                      slot: "second",
                      class: "second",
                      style: {"width":"100%"},
                      src: _unref(imageResult),
                      alt: ""
                    }, null, 8, _hoisted_5),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_inline_svg, {
                        src: require('@/assets/icons/slider.svg')
                      }, null, 8, ["src"])
                    ])
                  ]),
                  _: 1
                }, 8, ["style"]), [
                  [_vShow, imageTab.value === 'comparison']
                ]),
                _withDirectives(_createVNode(_component_v_img, {
                  src: _unref(imageResult),
                  alt: "#",
                  height: "100%",
                  ref_key: "mainImageRef",
                  ref: mainImageRef,
                  class: "second"
                }, {
                  placeholder: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(AiCircleLoader)
                    ])
                  ]),
                  _: 1
                }, 8, ["src"]), [
                  [_vShow, imageTab.value === 'after']
                ]),
                _withDirectives(_createVNode(_component_v_img, {
                  src: _unref(imageForActions),
                  alt: "#",
                  height: "100%",
                  class: "second"
                }, {
                  placeholder: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(AiCircleLoader)
                    ])
                  ]),
                  _: 1
                }, 8, ["src"]), [
                  [_vShow, imageTab.value === 'before']
                ])
              ], 4)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["result-image-controller", {'result-image-controller--mobile': _unref(isMobile)}])
            }, [
              _createVNode(AiButton, {
                theme: "dark",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (imageResult.value = ''))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.back')), 1)
                ]),
                _: 1
              }),
              _createVNode(AiButton, {
                theme: "dark",
                onClick: toEditHadler
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.edit')), 1)
                ]),
                _: 1
              }),
              _createVNode(AiButton, {
                theme: "dark",
                onClick: _cache[2] || (_cache[2] = ($event: any) => {
              imagePrev.value = '';
              imageForActions.value = '';
              imageResult.value = '';
              _unref(generateImageData).products = [];
            })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('services.reset')), 1)
                ]),
                _: 1
              }),
              (_unref(servicesList).length > 1)
                ? (_openBlock(), _createBlock(AiButton, {
                    key: 0,
                    theme: "dark",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (otherServiceModal.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('services.open-in')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(AiButton, {
                theme: "gradient-primary",
                class: "result-image-controller__button",
                onClick: _withModifiers(downloadHandler, ["stop"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_inline_svg, {
                    src: require('@/assets/icons/actions/download-with-line.svg')
                  }, null, 8, ["src"]),
                  _createTextVNode(" " + _toDisplayString(!_unref(isMobile) ? _ctx.$t('common.download') : ''), 1)
                ]),
                _: 1
              })
            ], 2)
          ])
        ]))
      : (_openBlock(), _createBlock(ImageFinetune, {
          key: 1,
          src: _unref(imageResult),
          onReset: resetHandler,
          onSave: editHandler,
          actions: ['reset', 'save']
        }, null, 8, ["src"])),
    _createVNode(AiBottomModal, {
      "show-modal": otherServiceModal.value,
      title: _ctx.$t('services.open-modal-title'),
      "handle-toggle": otherServiceModalCloseHandler,
      "no-height": ""
    }, {
      default: _withCtx(() => [
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(AiCircleLoader)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedMenuList.value, (service, index) => {
            return (_openBlock(), _createBlock(AiClearButton, {
              key: index,
              onClick: ($event: any) => (goToServiceHandler(service.service)),
              class: "services__list__item"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_inline_svg, {
                    src: service.icon
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("div", _hoisted_12, _toDisplayString(service.title), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["show-modal", "title"])
  ], 2))
}
}

})